import React from 'react';
import classNames from 'classnames';
/**
 * Bronson [Indicator Dot](https://bronson.vwfs.io/bluelabel/components/detail/bronson-indicator-dot.html) component.
 * @desc Visual indicator to communicate a status.
 * It includes default statuses like `default`, `info`, `success`, `warning`, `error` and a `unread` status, e.g. for messages.
 * @constructor
 */
export function IndicatorDot({ ariaLabelStatus, className, label, labelHidden = false, status, tooltip = null, testId, }) {
    const indicatorDotClassNameList = classNames({
        'c-indicator-dot': true,
        [`c-indicator-dot--${status}`]: status,
    }, className).trim();
    const indicatorDotLabelClassNameList = classNames('c-indicator-dot__label', {
        'u-visually-hidden': labelHidden,
    }).trim();
    return (React.createElement("span", { className: indicatorDotClassNameList, "data-testid": testId },
        tooltip ?? React.createElement("span", { className: "c-indicator-dot__dot", "aria-label": ariaLabelStatus }),
        React.createElement("span", { className: indicatorDotLabelClassNameList }, label)));
}
